import { createContext } from "react";
import defaultConfig from "./defaultConfig";
export default /*#__PURE__*/ createContext(defaultConfig);

//# sourceMappingURL=DataConfigContext.js.map